<template>
  <d-col cols="12" md="3" lg="3">
    <label for="processing-time">
      {{ $t('order.executionTime') }}:
    </label>

    <validation-provider
      rules="required"
      name="processing_time_id"
      v-slot="{ errors }">
      <div :class="{ 'form-control': true, 'is-select': true, 'is-invalid': errors.length }">
        <v-select
          :options="processingTimeOptions"
          v-model="processing_time_id"
          :searchable="false"
          :clearable="false"
          :reduce="processingTime => processingTime.value"
          :placeholder="$t('order.selectExecutionTime')"
          label="text">
          <template slot="no-options">
            {{ $t('ui.noAvailableValues') }}&hellip;
          </template>
        </v-select>
      </div>

      <div class="invalid-feedback">
        {{ errors[0] }}
      </div>
    </validation-provider>
  </d-col>
</template>

<script>
import AppConfig from './../../.env';
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'order-select-time',
  props: [
    'isOfferView'
  ],
  computed: {
    processingTimeOptions () {
      return this.processingTimes.map(processingTime => ({
        value: processingTime.id,
        text: processingTime.name
      }));
    }
  },
  watch: {
    loadError (newValue) {
      if (newValue) {
        this.$bus.$emit('order-data-fetch-error');
      }
    },
    loadedProcessingTimes (newValue) {
      if (newValue) {
        this.$bus.$emit('order-data-fetch-success', 'times');
      }
    }
  },
  data () {
    return {
      processing_time_id: 0,
      loadedProcessingTimes: false,
      processingTimes: [],
      loadError: false
    }
  },
  mounted () {
    FormUtils.loadAdditionalData(this, {
      endpoint: '/processing-time/items',
      loadedKey: 'loadedProcessingTimes',
      outputKey: 'processingTimes',
      errorKey: 'loadError',
      successAction: () => {
        this.processing_time_id = this.processingTimes[0].id;

        if (this.isOfferView) {
          let environment = AppConfig.useConfig;
          this.processing_time_id = AppConfig.additionalConfig[environment].offerProcessingTimeID;
        }
      }
    });
  }
}
</script>
